import { Box, styled, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { LwTab } from 'redesign';
import { EmployeeResponse } from 'api/services/workforce/workforce-service.types';
import { EmployeeInformationTab } from './employee-information-tab';
import { EmployeeFlexPools } from './employee-flexpools';

type PanelTabType = {
  id: React.ComponentProps<typeof Tab>['value'];
  tabLabel: React.ComponentProps<typeof Tab>['label'];
};

type Props = {
  data: EmployeeResponse;
};

export const EmployeeDetailTabs = ({ data }: Props) => {
  const tabs: PanelTabType[] = [
    {
      id: 'employee-information',
      tabLabel: 'Persoonlijke gegevens',
    },
    {
      id: 'employee-flexpools',
      tabLabel: 'Flexpools',
    },
  ];

  const [selectedTabId, setSelectedTabId] = useState(tabs[0].id);

  const renderTabContent = () => {
    switch (selectedTabId) {
      case 'employee-information':
        return <EmployeeInformationTab data={data} />;
      case 'employee-flexpools':
        return <EmployeeFlexPools flexWorkerId={data.id} />;
      default:
        return null;
    }
  };

  return (
    <Box>
      <Box mb={4}>
        <StyledTabs
          value={selectedTabId}
          onChange={(_, tabId) => {
            setSelectedTabId(tabId);
          }}
          aria-label="partner-detail-tabs"
        >
          {tabs.map((tab) => (
            <LwTab key={tab.id} value={tab.id} label={tab.tabLabel} />
          ))}
        </StyledTabs>
      </Box>
      <Box>{renderTabContent()}</Box>
    </Box>
  );
};

const StyledTabs = styled(Tabs)(({ theme }) => ({
  '& div.MuiTabs-scroller': {
    '& .MuiTabs-flexContainer': {
      gap: theme.spacing(2),
      overflow: 'visible',
    },
  },
}));
